// extracted by mini-css-extract-plugin
module.exports = {"page":"LoadingScreen_page__y07q5","loading":"LoadingScreen_loading__3UASA","logo":"LoadingScreen_logo__1Fnjv","pulse":"LoadingScreen_pulse__15OA4"};